import { render, staticRenderFns } from "./crudCourses.vue?vue&type=template&id=f0474060&"
import script from "./crudCourses.vue?vue&type=script&lang=js&"
export * from "./crudCourses.vue?vue&type=script&lang=js&"
import style0 from "./crudCourses.vue?vue&type=style&index=0&id=f0474060&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports